export const docToPostRef = doc => {
  const data = doc.data()
  return {
    docId: data.post_ref.id,
    like: data.like,
    like_date: data.like_date,
    like_at: data.like_at || 1,
    published_at: data.published_at,
    key: doc.id,
    score: data.score,
    tags: data.tags
  }
}

export const docToPostData = (doc, item) => {
  const data = JSON.parse(JSON.stringify(doc.data()))
  return {
    ...data,
    authorName: data.author.name,
    key: doc.id,
    published_at: item.published_at,
    like: item.like,
    score: item.score,
    tags: item.tags
  }
}



// WEBPACK FOOTER //
// ./src/converters/postConverter.js